Namespace('Monitoring.LiveReports.RealtimeMapContainer')

class Monitoring.LiveReports.RealtimeMapContainerView extends Backbone.View
  template: JST["backbone/templates/monitoring/live_reports/realtime_map/realtime_map_container"]
  className: 'live-report-container'

  events:
    'click #toggle-heatmap': 'onClickToggleHeatmap'

  initialize: (@options = {}) ->
    @mapView = new Monitoring.LiveReports.RealtimeMapView(@options)
    @sidebarView = new Monitoring.LiveReports.RealtimeMapSidebarView(@options)

    @listenTo(@mapView, 'added-layers', @onAddedLayers)
    @listenTo(@mapView, 'click-filter', @onClickFilter)
    @listenTo(@mapView, 'ready', @onReady)
    @listenTo(@mapView, 'drilldown', @onDrilldown)
    @listenTo(@sidebarView, 'open-filter', @onOpenFilter)
    @listenTo(@sidebarView, 'close-filter', @onCloseFilter)
    @listenTo(@sidebarView, 'selected-layer', @onSelectLayer)
    @listenTo(@sidebarView, 'deselected-layer', @onDeselectLayer)
    @listenTo(@sidebarView, 'apply', @onClickApply)

  render: ->
    @$el.html(@template(@))
    @$el.find('#last-map-container').html(@mapView.render())
    @$el.prepend(@sidebarView.render())
    @updateTimestamp()
    @$el

  initializeMap: (containerElementOrId) ->
    @mapView.initializeMap(containerElementOrId)

  onAddedLayers: (layerNames, layerVisibilities) ->
    @sidebarView.setLayerNames(layerNames, layerVisibilities)

  onClickFilter: ->
    @$el.find('.easy-button-container').toggleClass('with-expanded-sidebar')
    @sidebarView.toggle()

  onOpenFilter: ->
    @$el.find('.fa-filter').css({ color: 'white' })

  onCloseFilter: ->
    @$el.find('.fa-filter').css({ color: '' })

  onSelectLayer: (layerName) ->
    @mapView.addLayer(layerName)

  onDeselectLayer: (layerName) ->
    @mapView.removeLayer(layerName)

  onClickToggleHeatmap: ->
    @mapView.toggleHeatmap()

  onReady: ->
    @$el.find('.loader').addClass('hidden')
    @updateTimestamp()

  onClickApply: (updatedFilter) ->
    @mapView.setFilter(updatedFilter)
    @mapView.refresh()

  onDrilldown: (options) ->
    drilldownView = new Monitoring.LiveReports.RealtimeMapDrilldownView(options)
    @$el.find('.modal-container').append(drilldownView.render())
    drilldownView.show()

  updateTimestamp: ->
    now = new Date()
    time = now.toTimeString().split(' ')[0]
    @$el.find('.timestamp').html(time)
